export default "__VITE_ASSET__C7HX_flR__";